export const getAnalyticsClickData = (cls?: string, value?: string) => {
  return {
    click: {
      eventName: 'sportTopFilter_search_autocomplete_select',
      data: {
        cls,
        search_request: value,
        text: value,
      },
    },
  };
};

export const getAutocompleteOpenAnalytics = (cls: string) => {
  return {
    open: {
      eventName: 'sportTopFilter_search_open',
      data: {
        cls,
      },
    },
  };
};
